import {CaosCommand, Nullable} from "./caos-def";
import {isObjectOfType} from "./utils.objects";
import CommandLink from "./widgets/command_link";
import {CaosLib} from "./utils.caosdef";

/**
 * Checks if an object is a command
 * @param item
 */
export function isCommand(item: unknown): item is CaosCommand {
    return isObjectOfType<CaosCommand>(item, "id", "command");
}


export function descriptionWithLinks(
    caosLib: CaosLib,
    key: string,
    variants: number,
    description: Nullable<string>,
    pushPopupItem: (kind: string, id: number) => void
) {

    if (description == null || description.trim().length === 0) {
        return "";
    }

    description = description.trim();

    return description.split(/(\[[A-Z_$][A-Z0-9_$#:* +]+]|\\t|\t|\\n|\n|[$#]\{[^}]+}|\[.*?)/gi)
        .map((match, idx) => {
            return formatDescriptionPart(caosLib, variants, match, key, idx, pushPopupItem);
        });

}

export const linkTypeRegex = /^\[[A-Z_$][A-Za-z0-9_$:# +]+]$/i;

function formatDescriptionPart(
    caosLib: CaosLib,
    variants: number,
    text: string,
    prefix: string,
    idx: number,
    pushPopupItem: (kind: string, id: number) => void
) {

    if (text === "\n" || text === "\\n") {
        return <br key={prefix + '-br-' + idx}/>
    }

    if (text === "\\t" || text === "\t") {
        return <span key={prefix + '-tab-' + idx} className="tab" aria-hidden="true"></span>
    }

    if (text[0] === "$" || text[0] === "#") {
        return <span key={prefix + '-code-block-' + idx}
                     className="inline-code-block"
        >{text.substring(2, text.length-1)}</span>
    }

    if (linkTypeRegex.test(text)) {
        return <CommandLink
            caosLib={caosLib}
            key={prefix + '-command-link-' + idx}
            link={text}
            pushPopupItem={pushPopupItem}
            variants={variants}
        />
    } else {
        return text;
    }
}